module.exports = "https://cdn.realtymogul.com/static/media/slide_grow_bar_chart.eb102694.png";